import { forwardRef, useImperativeHandle, useRef } from "react";
import { Row } from "../../Flex";
import { Spacing, SpacingSizes } from "../../Spacing";
import {
  Container,
  ErrorMessage,
  Label,
  LeftContainer,
  TextInputComponent,
  TextInputContainer,
  styles,
} from "./styles";
import { TextInputProps, TextInputRef } from "./types";

export const TextInput = forwardRef<TextInputRef, TextInputProps>(
  (
    {
      label,
      placeholder = "",
      type = "text",
      onChangeText,
      value,
      error,
      leftIcon,
      onLeftIconClick,
      rightIcon,
      onRightIconClick,
      onFocusCallback,
      onBlurCallback,
      disabled,
      readOnly,
      onClick,
      ...controller
    },
    ref
  ) => {
    const inputRef = useRef<HTMLInputElement>(null);

    useImperativeHandle(ref, () => ({
      focus() {
        inputRef.current?.focus();
      },
      blur() {
        inputRef.current?.blur();
      },
    }));

    const disabledStyle = disabled ? styles.disabled : undefined;

    return (
      <TextInputContainer
        onMouseDown={(e) => {
          e.preventDefault();
        }}
        onClick={(e) => {
          inputRef.current?.focus();
          onClick?.();
        }}
        style={disabledStyle}
      >
        <Row>
          {leftIcon ? (
            <LeftContainer
              onClick={(e) => {
                e.stopPropagation();
                onLeftIconClick?.();
              }}
            >
              {leftIcon}
            </LeftContainer>
          ) : null}

          <Container onClick={onClick}>
            <Label>{label}</Label>
            <Spacing size={SpacingSizes.XS} />
            <TextInputComponent
              {...controller}
              ref={inputRef}
              type={type}
              placeholder={placeholder}
              value={value}
              onChange={(event) => {
                onChangeText?.(event.target.value);
              }}
              onFocus={onFocusCallback}
              onBlur={onBlurCallback}
              autoComplete="new-password"
              disabled={disabled}
              readOnly={readOnly}
              onClick={onClick}
            />
            <Spacing size={SpacingSizes.XS} />

            {error ? <ErrorMessage>{error}</ErrorMessage> : null}
          </Container>

          {rightIcon ? (
            <div
              onClick={(e) => {
                e.stopPropagation();
                onRightIconClick?.();
              }}
            >
              {rightIcon}
            </div>
          ) : null}
        </Row>
      </TextInputContainer>
    );
  }
);
